import {find, get, first, config} from 'helpers';
import {RootState} from 'store';

export function membership(state: RootState) {
  const {webPlan} = state.session.subscription;
  const archived = find(config.archivedPlans, {code: webPlan});
  const current = find(config.plans, {code: webPlan});

  let plans = config.plans.map(plan => ({
    ...plan,
    isCurrent: current?.code == plan.code,
    tip: getTipFor(plan, current || archived, first(config.plans)),
  }));

  return {
    archived,
    current,
    isWebPremium: Boolean(current || archived),
    plans,
    subscription: state.session.subscription,
    user: state.session.user,
  }
}

function getTipFor(plan, current, minPlan) {
  if (current && current.months > plan.months) {
    return '';
  } else if (get(current, 'code') == plan.code) {
    return 'Your current plan';
  } else if (current && plan.months > get(current, 'months', 1)) {
    const currentCost = (current || minPlan).cost * plan.months / (current || minPlan).months;
    if (currentCost) {
      const save = Math.round((1 - plan.cost / currentCost) * 100);
      return `Upgrade and save ${save}%`;
    }
  } else {
    return plan.tip;
  }
}
